import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import CustomToolTip from 'components/tooltip/customToolTip';
import { camelKeysToSnakeCaseKeys } from 'utils/caseConvertors';
import Toaster from 'components/Toaster';
import BusinessApi from 'apis/Business';
import BusinessCardWrapper from '../businessCardWrapper';
import LocationModal from '../modal/locationModal';
import LocationCode from './locationCode';

const BusinessLocationInfo = ({ locationData, fetchBusinessDetail, match }) => {
  const [isModalVisible, setModalVisibility] = useState(false);
  const {
    addressLine1,
    addressLine2,
    city,
    state,
    zip,
    primaryNumber,
    locationCode,
  } = locationData;

  const displayLocation = [addressLine1, addressLine2, city, state, zip]
    .filter(function(val) {
      return val;
    })
    .join(', ');

  const onSubmit = async values => {
    const { params } = match;
    const { id } = params;
    const newLocationData = camelKeysToSnakeCaseKeys(values);
    const data = {
      business: {
        ...newLocationData,
      },
    };
    BusinessApi.update(id, data)
      .then(() => {
        Toaster.getSuccessToaster(
          'check-circle',
          'Successfully updated location code'
        );
        setModalVisibility(false);
        fetchBusinessDetail();
      })
      .catch(() =>
        Toaster.getErrorToaster(
          'exclamation-triangle',
          'Failed to update location code'
        )
      );
  };

  return (
    <BusinessCardWrapper iconLeft="map-marker-alt" title="Business Location">
      <LocationModal
        isVisible={isModalVisible}
        handleSubmit={onSubmit}
        onCancel={() => setModalVisibility(false)}
        locationData={locationData}
      />
      <div className="p-3">
        <div className="location-card mb-3 d-none">
          <div className="card-status">
            <FontAwesomeIcon icon="check-circle" className="disabled-status" />
          </div>
          <div className="location-address">
            {displayLocation}
            <CustomToolTip
              target="locationAddress2"
              toolTipText="Edit Address"
              icon="pencil-alt"
              iconClassName="hover-edit-btn"
              onClick={() => setModalVisibility(!isModalVisible)}
            />
          </div>
          <hr />
          <div className="location-address">
            <span className="thin-font-weight">Location Code: </span>
            {locationCode}{' '}
            <CustomToolTip
              target="locationCode2"
              toolTipText="Edit Location Code"
              icon="pencil-alt"
              iconClassName="hover-edit-btn"
              onClick={() => setModalVisibility(!isModalVisible)}
            />
          </div>
        </div>
        <div className="location-card shadow-2">
          <div className="card-status active-card">
            <FontAwesomeIcon icon="check-circle" className="active-status" />
          </div>
          <div className="location-address">
            {displayLocation}
            <CustomToolTip
              target="locationAddress"
              toolTipText="Edit Address"
              icon="pencil-alt"
              iconClassName="hover-edit-btn"
              onClick={() => setModalVisibility(!isModalVisible)}
            />
          </div>
          <hr />
          <div className="location-address">
            <LocationCode locationCode={locationCode} onSubmit={onSubmit} />
          </div>
        </div>
        <div className="pt-3 pb-1 d-none">
          <button
            type="button"
            className="btn btn-link text-secondary card-link-btn"
          >
            <FontAwesomeIcon icon="plus" className="text-primary" /> Add a new
            location
          </button>
        </div>
      </div>
    </BusinessCardWrapper>
  );
};

export default withRouter(BusinessLocationInfo);



// WEBPACK FOOTER //
// ./src/components/businessDetail/businessLocation/locationInfo.js